import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AtomService } from 'src/app/core/atom.service';
import { SearchRessourceComponent } from './search-ressource/search-ressource.component';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { resourcesMatch } from 'json-api';

@Component({
  selector: 'atm-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  @Input() config!: any;
  @Input() disabled: boolean = false;
  @Output() selected = new EventEmitter<any>();
  @Output() setDefaultValue = new EventEmitter<any>();
  resources$!: Observable<any[]>;

  @Input() get resource(): any {
    return this._resource;
  }
  set resource(value: any) {
    this._resource = value;
  }
  @Input() filterSetted: string | null = null;
  @Input() hasDefault: boolean = true;
  @Input() defaultValue: any;

  public _resource = null;
  compare = resourcesMatch;

  constructor(private atom: AtomService, public dialog: MatDialog) {}

  ngOnInit(): void {
    if (this.config.list) {
      this.resources$ = this.atom.list(this.config.resource, {
        include: this.config.include,
      });
      this.resources$.subscribe();
    }
  }

  removeAt(index: number): void {
    this.resource = this.resource.filter((_: any, i: number) => i !== index);
    this.selected.emit(this.resource);
  }

  onSelectionChange($event: any) {
    if (this.config.multiple && !this.config.list) {
      if ($event) {
        if (!this.resource) {
          this.resource = [];
        }
        this.resource.push($event);
      }
    } else {
      this.resource = $event;
    }
    this.selected.emit(this.resource);
  }

  selectDefault(resource: any) {
    if (this.hasDefault) {
      this.defaultValue = resource;
      this.setDefaultValue.emit(resource);
    }
  }

  openDialog() {
    this.dialog
      .open(SearchRessourceComponent, {
        data: { conf: this.config, closeAfterSelect: true },
        width: '1152px',
        height: '652px',
      })
      .afterClosed()
      .subscribe((value: any) => {
        this.onSelectionChange(value);
      });
  }

  isEmpty(elem: any): boolean {
    if (Array.isArray(elem)) {
      return elem.length > 0;
    }
    return !!elem;
  }
}
